/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Assistant_Activity_SettingsInputs */



/**
* | output |
* | --- |
* | "Changed the settings of {group}" |
*
* @param {Assistant_Activity_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_settings = /** @type {((inputs: Assistant_Activity_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Paramètres de ${i?.group} modifiés`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Einstellungen von ${i?.group} wurden geändert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Modificate le impostazioni di ${i?.group}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Изменены настройки ${i?.group}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se modificaron los ajustes de ${i?.group}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`更改了 ${i?.group} 的设置`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.group} の設定を変更しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.group} की सेटिंग्स बदल दी गईं`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Alterei as configurações de ${i?.group}`)
	return /** @type {LocalizedString} */ (`Changed the settings of ${i?.group}`)
});